import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../store/theme.actions';
import { NotasFiscais } from './NotasFiscais';
import NotasFiscaisProvider from '../../store/NotasFiscais/NotasFiscaisProvider';

function NotasFiscaisPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Notas Fiscais'));

  return (
    <NotasFiscaisProvider>
      <NotasFiscais />
    </NotasFiscaisProvider>
  );
}

export default withTokenInterceptor(NotasFiscaisPage);
